// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .sizing-group-header {
  padding: 24px 34px;
  background: #fafafa;
  border-bottom: 1px solid #efefef;
  position: sticky;
  left: 0;
}
.presize-root .sizing-group-header .anticon {
  color: #a2a3a8;
}
.presize-root .order-reference-brand-button {
  border: 1px solid #efefef;
}
.presize-root .order-reference-brand-selector {
  min-width: 150px;
}
.presize-root .enable-box-label {
  margin-right: 8px;
}
/*# sourceMappingURL=SizingGroupListHeader.css.map */`, "",{"version":3,"sources":["webpack://./SizingGroupListHeader.less","webpack://./src/components/SizingGroupListHeader/SizingGroupListHeader.less"],"names":[],"mappings":"AAAA;EAEE,kBAAA;EACA,mBAAA;EACA,gCAAA;EAIA,gBAAA;EACA,OAAA;ACHF;ADNA;EAMI,cAAA;ACGJ;ADTA;EAYE,yBAAA;ACAF;ADZA;EAeE,gBAAA;ACAF;ADfA;EAkBE,iBAAA;ACAF;AACA,oDAAoD","sourcesContent":[".presize-root { \n .sizing-group-header {\n  padding: 24px 34px;\n  background: #fafafa;\n  border-bottom: 1px solid #efefef;\n  .anticon {\n    color: #a2a3a8;\n  }\n  position: sticky;\n  left: 0;\n}\n.order-reference-brand-button {\n  border: 1px solid #efefef;\n}\n.order-reference-brand-selector {\n  min-width: 150px;\n}\n.enable-box-label {\n  margin-right: 8px;\n}\n \n}",".presize-root .sizing-group-header {\n  padding: 24px 34px;\n  background: #fafafa;\n  border-bottom: 1px solid #efefef;\n  position: sticky;\n  left: 0;\n}\n.presize-root .sizing-group-header .anticon {\n  color: #a2a3a8;\n}\n.presize-root .order-reference-brand-button {\n  border: 1px solid #efefef;\n}\n.presize-root .order-reference-brand-selector {\n  min-width: 150px;\n}\n.presize-root .enable-box-label {\n  margin-right: 8px;\n}\n/*# sourceMappingURL=SizingGroupListHeader.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
